import { render, staticRenderFns } from "./CartFooter.html?vue&type=template&id=aafac842&scoped=true&"
import script from "./CartFooter.js?vue&type=script&lang=js&"
export * from "./CartFooter.js?vue&type=script&lang=js&"
import style0 from "./CartFooter.scss?vue&type=style&index=0&id=aafac842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafac842",
  null
  
)

export default component.exports